
import { questionTypeEnum } from 'assets/constants';
const { singleSelection, multiSelection, freeText } = questionTypeEnum


export function getQuestionsAfterProperty(properties, startPropertyId) {
    const validTypes = [singleSelection, multiSelection, freeText];

    const startIndex = properties.findIndex(prop => prop.propertyId === startPropertyId);
    if (startIndex === -1) return [];

    return properties
        .slice(startIndex + 1)
        .filter(prop => validTypes.includes(prop.type) && prop?.value?.question?.questionKey)
        .map(prop => ({
            questionKey: prop.value.question.questionKey,
            propertyId: prop.propertyId,
        }));
}

export function isQuestionBeforeWidgetChanged(properties, propertyId, widgetTypes) {
    const targetIndex = properties.findIndex(
        prop =>
            prop.propertyId === propertyId &&
            [singleSelection, multiSelection, freeText].includes(prop.type) &&
            prop?.value?.question?.questionKey
    );
    if (targetIndex === -1) return false;
    return properties.slice(targetIndex + 1).some(prop => widgetTypes.includes(prop.type));
}

export function removeQuestionKeys(currentStepQuestions, keysToRemove) {
    const filtered = { ...currentStepQuestions };
    keysToRemove.forEach(key => {
        delete filtered[key];
    });
    return filtered;
}

export function extractQuestionKeys(array) {
    return array.map(item => item.questionKey).filter(Boolean);
}